// @ts-nocheck
import {
  Autocomplete,
  CircularProgress,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import { apiRequest } from "../../../../../services/apiService";
import { useCallback } from "react";
import { useEffect } from "react";
import PropTypes from "prop-types";
import GenericTransparentBtn from "../../../../../components/Custom/GenericTransparentBtn";
import { Close } from "@mui/icons-material";

export const CustomBusinessInput = ({
  onChange,
  value,
  readOnly,
  handleBlur,
  inputName = "companyName",
}) => {
  const [inputVal, setInputVal] = useState("");
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchBusiness = useCallback(async () => {
    setIsLoading(true);
    const { response } = await apiRequest({
      method: "GET",
      url: "getThirdPartyContractors",
      params: { search: inputVal },
      isToken: true,
    });

    setIsLoading(false);
    setOptions(response?.status === 200 ? response?.data?.data : []);
  }, [inputVal]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      fetchBusiness();
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [inputVal, fetchBusiness]);

  return (
    <Autocomplete
      readOnly={readOnly}
      fullWidth
      value={value ?? null}
      onChange={(_, newValue) => onChange(newValue)}
      freeSolo={false}
      options={options}
      inputValue={inputVal}
      autoHighlight
      onInputChange={(_, newValue) => setInputVal(newValue)}
      ListboxProps={{ className: "custom-scroll-design" }}
      filterOptions={(x) => x}
      sx={{
        "& .MuiAutocomplete-clearIndicator": {
          visibility: value?.companyName ? "visible" : "hidden",
        },
        height: "50px",
        "& button": {
          color: "white",
        },
      }}
      clearIcon={
        <GenericTransparentBtn
          style={{
            background: "grey",
            padding: "0.10rem",
            visibility: value?.airportName ? "visible" : "hidden",
            borderRadius: "50%",
            onHover: {
              background: "grey",
              padding: "0.10rem",
            },
          }}
        >
          <Close
            sx={{
              fontSize: "1rem",
            }}
          />
        </GenericTransparentBtn>
      }
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Search business name"
          InputLabelProps={{ style: { color: "white" } }}
          name={inputName}
          onBlur={handleBlur}
          sx={{
            "& .MuiOutlinedInput-root": {
              paddingY: "7px !important",
              "& fieldset": { borderRadius: "8px", borderColor: "white" },
              "&:hover fieldset, &.Mui-focused fieldset": {
                borderColor: "white",
              },
              color: "white",
            },
            "& .MuiInputBase-input": { color: "white" },
            "& .MuiAutocomplete-popupIndicator": { color: "white" },
          }}
        />
      )}
      getOptionLabel={(option) => option?.companyName}
      renderOption={(props, option) => (
        <li {...props} key={option._id}>
          {option.companyName}{" "}
        </li>
      )}
      PaperComponent={({ children }) => (
        <Paper
          sx={{
            background: "black",
            outline: "1px solid white",
            borderRadius: "8px",
            color: "white",
          }}
        >
          {isLoading ? (
            <Box
              sx={{
                padding: "0.5rem",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <CircularProgress size={22} />
            </Box>
          ) : options.length === 0 ? (
            <Box
              sx={{
                padding: "0.5rem",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Typography>No options</Typography>
            </Box>
          ) : (
            children
          )}
        </Paper>
      )}
    />
  );
};

CustomBusinessInput.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.any,
  readOnly: PropTypes.bool,
  handleBlur: PropTypes.func,
  inputName: PropTypes.string,
};